/**
 * Http client. Makes http request to the backend. Add more methods, if need.
 */
export default {
	/**
	 * Makes POST request
	 * @param {string} url
	 * @param {*|FormData} data
	 * @param {function} callback Signature of the callback: `function (error, response)`.
	 * If error is null, then success response.
	 * @param {XMLHttpRequestResponseType} responseType
	 */
	post(url, data, callback, responseType = 'text') {
		let formData = null;

		if (data instanceof FormData) {
			formData = data;
		} else if (data && typeof data === 'object' && !Array.isArray(data)) {
			formData = new FormData();

			for (const name in data) {
				formData.append(name, data[name]);
			}
		}

		if (!formData) {
			return;
		}

		const xhr = new XMLHttpRequest();
		xhr.open('POST', url);
		xhr.responseType = responseType;

		xhr.send(formData);

		xhr.onload = function () {
			if (+xhr.status !== 200) {
				callback(new Error('Error ' + xhr.status + ': ' + xhr.statusText));
			} else {
				callback(null, xhr.response);
			}
		};

		xhr.onerror = function () {
			callback(new Error('Request failed'));
		};
	},
};
